<template>
  <div>
    <page-main
      ref="tree"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @addTop="$emit('addTop')"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
  },
  mixins: [BaseTable],
  mounted() {
    this.$eventBus.$on('selectTreeList', () => {
      this.getData({})
    })
  },
  data() {
    return {
      usePage: true,
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterLocationLeftListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          store.commit('setSelected', this.tableData[0])
          this.$nextTick(() => {
            this.$refs.tree.expandTree()
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
